/**
 * File: diagnosticsViewUtils.ts
 * Path: apps/admin/src/features/diagnostics/utils/diagnosticsViewUtils.ts
 * Description: The words the Diagnostics page shows: the one-line headline over all checks and the time
 * stamp on a recorded error.
 */

import { worstStatus, type CheckStatus, type DiagnosticCheck } from "@idk/config";

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

export const headlineOf = (
  checks: readonly DiagnosticCheck[],
  checking: boolean,
): { status: CheckStatus; text: string } => {
  const status = worstStatus(checks);
  const fails = checks.filter((c) => c.status === "fail").length;
  const warns = checks.filter((c) => c.status === "warn").length;
  const text = checking
    ? "Checking…"
    : status === "ok"
      ? "Everything checked is working."
      : [fails > 0 ? plural(fails, "problem", "problems") : null, warns > 0 ? plural(warns, "warning", "warnings") : null]
          .filter(Boolean)
          .join(" and ") + ". Each one says what to do.";
  return { status, text };
};

export const formatErrorTime = (at: number | string | Date): string =>
  new Date(at).toLocaleString("en-ZA", { dateStyle: "medium", timeStyle: "short" });
